export default "__VITE_ASSET__DyqWn4Yl__"